import Vue from 'vue'
import VueBarcode from 'vue-barcode';

Vue.use(VueBarcode);

Vue.component('barcode', VueBarcode);
